export default __webpack_public_path__ + "static/media/talking-in-group-2021-09-24-02-41-00-utc.4d826e8f.jpg";